import { sqrt } from "../math.js";
export default {
    draw: function (context, size) {
        var w = sqrt(size);
        var x = -w / 2;
        context.rect(x, x, w, w);
    }
};
